module.exports = __webpack_public_path__ + "img/crown3.fd10f2bc.png";